/**
 * Fetch every page of GET /api/v2/shipments and return one concatenated list.
 *
 * The list endpoint is server-paginated (default limit 20, max 100). The
 * workspace sidebar renders the full request history with no pagination
 * controls, so a single unparameterized fetch silently truncates to the
 * newest 20 rows once a tenant crosses that count (MTEU-747: GCS lost
 * sight of every request older than 7/10). Page-looping here keeps
 * truncation impossible at the one surface that promises completeness.
 *
 * PAGE_CAP bounds the fan-out for pathological tenants; if a tenant ever
 * exceeds it, the sidebar needs real pagination — not a bigger cap.
 */
const PAGE_LIMIT = 100
const PAGE_CAP = 20

export default async function fetchAllShipments(api) {
  const first = await api.listShipments({ page: 1, limit: PAGE_LIMIT })
  const data = first?.data || []
  const totalPages = Math.min(first?.meta?.totalPages || 1, PAGE_CAP)
  if (totalPages <= 1) return { data, meta: first?.meta }

  const restPages = []
  for (let page = 2; page <= totalPages; page++) restPages.push(page)
  const rest = await Promise.all(
    restPages.map(page => api.listShipments({ page, limit: PAGE_LIMIT }))
  )
  return {
    data: rest.reduce((acc, res) => acc.concat(res?.data || []), data.slice()),
    meta: first?.meta
  }
}
